import useAppView from 'Core/Hooks/useAppView'
import useMultiSlice from 'Core/Hooks/useMultiSlice'
import { cn } from 'Utils/Helpers'
import { getAccountIcon } from 'Utils/PureHelperFuctions'
import { LabelContent } from 'V2Components'
import { getResourceName, getRsrcIcon } from 'features/resources'
import { getApplicationType, useAppDetailsContext } from 'features/snowflake'
import { getHTMLDataTestID } from 'infra/utils'
import moment from 'moment'
import { CloudIcon, Label, RiskIndicator, Typography } from 'procyon-ui'
import React from 'react'

function OverviewTab() {
  const { app } = useAppDetailsContext()
  const { appView } = useAppView()
  const appType = getApplicationType(app)
  const { getObjectRef } = useMultiSlice(['accountList'])
  const Icon = getRsrcIcon(app)
  const account = getObjectRef(app?.Spec.Account)
  const AccountIcon = getAccountIcon(account?.Spec.Type)

  const getActiveStatus = (app) => {
    if (app.Spec.AppType === 'databricks') {
      return app.Spec.SalesforceAppConfig.Status.Status === 'Fail' ? 'offline' : 'online'
    }
  }

  return (
    <div className='flex gap-8'>
      <div className={cn('w-1/2 ', ' pr-8')}>
        <Typography variant='h4-regular'>Resource Information</Typography>
        <div className='mt-8'>
          {
            <LabelContent
              title='Status'
              data-testid={'target'}
              content={
                <>
                  <RiskIndicator variant={getActiveStatus(app)} />
                </>
              }
            />
          }
          <LabelContent title='Application Name' content={getResourceName(app)} />
          <LabelContent
            title='Application Type'
            content={
              <Label
                style={{ marginLeft: '0px' }}
                //@ts-ignore
                text={
                  <div className='flex gap-2 items-center'>
                    {Icon && <Icon />}
                    <strong>{appType}</strong>
                  </div>
                }
              />
            }
          />
          {account && (
            <LabelContent
              title='Account'
              content={
                <div className='flex gap-2 items-center'>
                  {AccountIcon && <AccountIcon />}
                  {getResourceName(account)}
                </div>
              }
            />
          )}
          <LabelContent
            title={'Cloud Type'}
            content={<CloudIcon type={app.Spec.DatabricksAppConfig.CloudType.toLowerCase()} />}
          />
          <LabelContent
            title='Created On'
            content={moment(app?.ObjectMeta.CreatedAt).format('DD MMMM, YYYY HH:mm:ss A')}
          />
          <LabelContent
            title='Last Updated On'
            content={moment(app?.ObjectMeta.UpdatedAt).format('DD MMMM, YYYY HH:mm:ss A')}
          />
        </div>
      </div>
    </div>
  )
}

export { OverviewTab }
